import React from "react";
import { shallowEqual } from "react-redux";
import * as Styles from "../common/styles/TradeInAem";
import { TradeInAemLabel, useTradeInAemOptionalLabel } from "../../../utils/labels";
import { useTradeInAemSelector } from "../../../redux/store";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";

type TradeInAemSummaryDisclaimersType = {
    isPdf?: boolean;
};

const TradeInAemSummaryDisclaimers = (props: TradeInAemSummaryDisclaimersType): JSX.Element | null => {
    const { isPdf } = props;

    const csl = useTradeInCsl();

    const vehicleValue = useTradeInAemSelector(csl.vehicleValueSelector, shallowEqual);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const disclaimerLabel = useTradeInAemOptionalLabel("tradeInAemDisclaimer");
    const validityDate = vehicleValue?.validityDate;

    if (!validityDate && !disclaimerLabel) return null;

    const dateFormat = new Intl.DateTimeFormat(commonSettings.culture.name, {
        day: "numeric",
        month: "long",
        year: "numeric",
    });

    const formattedValidityDate = validityDate ? dateFormat.format(new Date(validityDate)) : "";

    return (
        <Styles.Disclaimer isPdf={isPdf}>
            {!!formattedValidityDate && (
                <p>
                    <strong>
                        <TradeInAemLabel
                            label="tradeInAemOfferValid"
                            params={{
                                value: formattedValidityDate,
                            }}
                        />
                    </strong>
                </p>
            )}
            {!!disclaimerLabel && <p>{disclaimerLabel}</p>}
        </Styles.Disclaimer>
    );
};
export default TradeInAemSummaryDisclaimers;
